import React from 'react';
import { ErrorMessage, FormikValues } from 'formik';
import { ActionCheckbox } from '~/components/Patient/Gap/Actions';
import { enums, getFocActionName } from '~/util';

export interface FocActionCheckRowProps {
    action: FocActionType;
    checkboxId: string;
    readOnly: boolean;
    formik: FormikValues;
}

export function FocActionCheckRow({
    action,
    checkboxId,
    readOnly,
    formik,
}: FocActionCheckRowProps) {
    return (
        <>
            <tr
                className={`foc-gap-action-row gap-action-row ${
                    formik.errors[checkboxId] && formik.touched[checkboxId] ? 'text-danger' : ''
                }`}
            >
                <td className="checkbox-col" aria-label="Checkbox">
                    <div className="text-center">
                        <ActionCheckbox checkBoxId={checkboxId} readOnly={readOnly} />
                    </div>
                </td>
                <td className="col-gap-action-name">
                    <label htmlFor={checkboxId} className="mb-0">
                        {getFocActionName(action)}
                    </label>
                </td>
                <td className="w-20">{action.foc_action_details?.[0]?.acceptable_dates}</td>
                <td className="w-10">
                    {enums(['gap', 'frequency', action.foc_action_details[0].frequency!])}
                </td>
            </tr>
            {formik.errors[checkboxId] && (
                <tr className="quality-gap-action-row">
                    <td colSpan={4} aria-label="Error">
                        <div className="text-danger">
                            <ErrorMessage name={checkboxId} />
                        </div>
                    </td>
                </tr>
            )}
        </>
    );
}
